"use client";

import React, { FC, PropsWithChildren } from "react";
import {
  GlobalStateProvider,
  ShaApplicationProvider,
  StoredFilesProvider,
  useNextRouter,
} from "@shesha-io/reactjs";
import {
  GlobalPublicPortalStyles,
  PublicPortalApplicationPlugin,
} from "@shesha-io/pd-publicportal";
import { ContentApplicationPlugin } from "@shesha-io/content";
import {
  DsdNpoApplicationPlugin
} from "@shesha-io/dsd-npo";
import { WorkflowApplicationPlugin } from "@shesha-io/workflow";
import { EnterpriseApplicationPlugin } from "@shesha-io/enterprise";
import { ProgressBar } from "./progressBar";

export interface IAppProviderProps {
  backendUrl: string;
}

export const AppProvider: FC<PropsWithChildren<IAppProviderProps>> = ({
  children,
  backendUrl,
}) => {
  const nextRouter = useNextRouter();

  const noAuth =
    nextRouter.path?.includes("/no-auth");

  return (
    <GlobalStateProvider>
      <ShaApplicationProvider
        backendUrl={backendUrl}
        router={nextRouter}
        noAuth={noAuth}
        applicationKey="public-portal"
      >
        <ProgressBar />
        <GlobalPublicPortalStyles />
        <EnterpriseApplicationPlugin>
          <ContentApplicationPlugin>
            <WorkflowApplicationPlugin>
              <DsdNpoApplicationPlugin>
                <PublicPortalApplicationPlugin>
                  <StoredFilesProvider
                    baseUrl={backendUrl}
                    ownerId={""}
                    ownerType={""}
                  >
                    {children}
                  </StoredFilesProvider>
                </PublicPortalApplicationPlugin>
              </DsdNpoApplicationPlugin>
            </WorkflowApplicationPlugin>
          </ContentApplicationPlugin>
        </EnterpriseApplicationPlugin>
      </ShaApplicationProvider>
    </GlobalStateProvider>
  );
};
